import React from 'react';
import { Outlet } from 'react-router-dom';
import { AppSidebar, AppFooter, AppHeader } from '../components/index';
import { ActiveLinkProvider } from '../components/ActiveLinkContext';

import '../scss/main.scss';

// Public version of DefaultLayout without authentication requirements
const PublicDefaultLayout = () => {
  return (
    <ActiveLinkProvider>
      <div>
        <AppSidebar />
        <div className="wrapper d-flex flex-column min-vh-100 mieros-gradient-bg">
          <AppHeader />
          <div className="body flex-grow-1 px-3">
            <Outlet />
          </div>
          <AppFooter />
        </div>
      </div>
    </ActiveLinkProvider>
  );
};

export default PublicDefaultLayout; 